// ABOUTME: Displays one summarized UPM hierarchy item in role views.
// ABOUTME: Presentational only; data is fetched by parent components/hooks.

import {PlantHierarchyNode} from '@hconnect/apiclient'
import {LabelRegular, TextMedium} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../hooks/useTranslation'

type RoleUpmHierarchyChipProps = {
  item: PlantHierarchyNode
}

export const RoleUpmHierarchyChip = ({item}: RoleUpmHierarchyChipProps) => {
  const {t} = useTranslation()
  const hierarchyTypeLabel = t(`roleAssignment.upmHierarchyType.${item.type}`)

  return (
    <div
      className="border-1px border-border_highlight_10 rounded-lg py-2 px-3 flex flex-col items-start"
    >
      <div
        data-test-id={`role-upm-hierarchy-chip-${item.hierarchyId}`}
        className="flex flex-col items-start"
      >
        <LabelRegular className="text-foreground_faded">{hierarchyTypeLabel}</LabelRegular>
        <TextMedium className="text-foreground">{item.name}</TextMedium>
        <LabelRegular className="text-foreground_faded"> {item.hierarchyId}</LabelRegular>
      </div>
    </div>
  )
}
